import { render, staticRenderFns } from "./DosentWantOurProductDialog.vue?vue&type=template&id=07537eae&"
import script from "./DosentWantOurProductDialog.vue?vue&type=script&lang=js&"
export * from "./DosentWantOurProductDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports